import { render } from "./contact-form.vue?vue&type=template&id=4c31de1b"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__